// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"187":"e960d326","369":"a04221ad"}[chunkId] + ".css";
};